import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoutesPath } from '@shared/constants';
import { UserStore } from '@stores';

export const dashboardGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userStore = inject(UserStore);
  const user = userStore.read();

  if (user?.role === 'USER') {
    return router.createUrlTree([RoutesPath.HOME]);
  }
  return true;
};
